<section class="absolute mt-2 mb-20 ml-2 w-2xl z-10">
    <!--article class="header flex h-16 w-[32.688rem] primary-green-2-background items-center rounded-t-lg">
        <div class="cursor-pointer" (click)="goBack()">
            @if (showTripDetails) {
                <img [src]="images.arrowLeft" class="h-6 w-6 ml-4" />
            }
        </div>
        <h1 class="text-[22px] font-bold" [ngClass]="{'ml-4': !showTripDetails, 'ml-2': showTripDetails}">{{ literalService.get('trips.name', true) }}</h1>
    </article-->

        <article class="flex bg-white justify-start primary-green-2-background items-center p-4" [ngClass]="{'hidden': showTripDetails}">
            <app-trip-search-bar
            [placeholder]="literalService.get('trips.search', true)"
            [searching]="searching"
            [searchValue]="searchValue"
            (filter)="filter($event)"
            (searchEventEmitter)="search($event)"
          ></app-trip-search-bar>
            <!--label [id]="expeditionStatus.ONGOING" class="font-semibold text-lg mr-2 w-full text-center cursor-pointer" (click)="statusSelected = expeditionStatus.ONGOING; changeStatus(expeditionStatus.ONGOING)">{{ literalService.get('trips.' + expeditionStatus.ONGOING.valueOf(), true) }}</label>
            <label [id]="expeditionStatus.READY" class="font-semibold text-lg mr-2 w-full text-center cursor-pointer" (click)="statusSelected = expeditionStatus.READY; changeStatus(expeditionStatus.READY)">{{ literalService.get('trips.' + expeditionStatus.READY.valueOf(), true) }}</label>
            <label [id]="expeditionStatus.OPEN" class="font-semibold text-lg mr-2 w-full text-center cursor-pointer" (click)="statusSelected = expeditionStatus.OPEN; changeStatus(expeditionStatus.OPEN)">{{ literalService.get('trips.' + expeditionStatus.OPEN.valueOf(), true) }}</label>
            <label [id]="expeditionStatus.CLOSED" class="font-semibold text-lg mr-2 w-full text-center cursor-pointer" (click)="statusSelected = expeditionStatus.CLOSED; changeStatus(expeditionStatus.CLOSED)">{{ literalService.get('trips.' + expeditionStatus.CLOSED.valueOf(), true) }}</label-->
        </article>
        <!--article class="flex bg-white justify-around primary-green-2-background items-center pl-4 pr-4 pt-2">
            <div class="w-full mr-2" [ngClass]="{'h-1 primary-green-background': statusSelected === expeditionStatus.ONGOING, 'h-[2px] neutrals-grey-02-background': statusSelected !== expeditionStatus.ONGOING }"></div>
            <div class="w-full mr-2" [ngClass]="{'h-1 primary-green-background': statusSelected === expeditionStatus.READY, 'h-[2px] neutrals-grey-02-background': statusSelected !== expeditionStatus.READY}"></div>
            <div class="w-full mr-2" [ngClass]="{'h-1 primary-green-background': statusSelected === expeditionStatus.OPEN, 'h-[2px] neutrals-grey-02-background': statusSelected !== expeditionStatus.OPEN }"></div>
            <div class="w-full mr-2" [ngClass]="{'h-1 primary-green-background': statusSelected === expeditionStatus.CLOSED, 'h-[2px] neutrals-grey-02-background': statusSelected !== expeditionStatus.CLOSED }"></div>
        </article-->
    @if (!showTripDetails) {
        <article class="bg-white rounded-b-lg p-4 pb-14">
            <div class="grid grid-cols-11 ml-4 mr-4 mb-4 text-center">
                <label class="flex justify-center items-center col-span-4">
                    <img [src]="images.trips.name" alt="name" class="h-6 w-6" />
                </label>
                <label class="flex justify-center items-center col-span-1">
                    <img [src]="images.trips.date" alt="date" class="h-6 w-6" />
                </label>
                <label class="flex justify-center items-center col-span-2">
                    <img [src]="images.trips.driver" alt="driver" class="h-6 w-6" />
                </label>
                <label class="flex justify-center items-center col-span-2">
                    <img [src]="images.trips.vehicle" alt="vehicle" class="h-6 w-6" />
                </label>
                <label class="flex justify-center items-center col-span-2">
                    <img [src]="images.moreOptions" alt="moreOptions" class="h-6 w-6" />
                </label>
            </div>
            @if (!trips.isFetchingTrips) {
                @for (trip of trips.value; track $index) {
                    <app-trip-row [trip]="trip"
                                [language]="language"
                                [index]="$index"
                                (getTripEventEmitter)="getTripDetails($event)"
                                (showChangeDriverEventEmitter)="showChangeDriverEventEmitter.emit($event)"
                                (showChangeVehicleEventEmitter)="showChangeVehicleEventEmitter.emit($event)"
                                (showEditCommentEventEmitter)="showEditCommentEventEmitter.emit($event)"
                                (showViewBookingsEventEmitter)="showViewBookingsEventEmitter.emit($event)"
                                (showSetReadyEventEmitter)="showSetReadyEventEmitter.emit($event)"
                                (showSetClosedEventEmitter)="showSetClosedEventEmitter.emit($event)"
                                (showDeleteTripEventEmitter)="showDeleteTripEventEmitter.emit($event)"/>
                }
            } @else {
                <ngx-skeleton-loader [count]="trips.pagination.numberOfElements || 8" appearance="line" [theme]="{ 'height': '60px', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
            }
            @if (trips.value.length > 0 || trips.isFetchingTrips) {
                <div class="mt-6">
                    <app-pagination [pagination]="trips.pagination" [right]="false" [loading]="trips.isFetchingTrips && !trips.pagination.totalPages" [baseUrl]="'/trips'" (changePage)="changePage($event)" />
                </div>
            }
        </article>
    } @else if (tripDetails) {
        <div class="p-4 bg-white relative max-h-[calc(100vh-7rem)] flex flex-col">
            <article class="pb-1">
                <app-trip-row [trip]="selectedTrip"
                [language]="language"
                [tripDetails]="!!tripDetails"
                (getTripEventEmitter)="getTripDetails($event)"
                (showChangeDriverEventEmitter)="showChangeDriverEventEmitter.emit($event)"
                (showChangeVehicleEventEmitter)="showChangeVehicleEventEmitter.emit($event)"
                (showEditCommentEventEmitter)="showEditCommentEventEmitter.emit($event)"
                (showViewBookingsEventEmitter)="showViewBookingsEventEmitter.emit($event)"
                (showSetReadyEventEmitter)="showSetReadyEventEmitter.emit($event)"
                (showSetClosedEventEmitter)="showSetClosedEventEmitter.emit($event)"
                (showDeleteTripEventEmitter)="showDeleteTripEventEmitter.emit($event)"/>
            </article>
            <article class="pb-2">
                <div class="flex items-center w-full">
                    <label class="w-27.5 shrink-0 text-center font-semibold text-base" [tooltip]="literalService.get('trips.tooltips.arrivalDeparture', true)" [position]="TooltipPosition.BELOW">{{ literalService.get('trips.arrivalDeparture') }}</label>
                    <div class="flex neutrals-grey-01-background justify-between items-center flex-1 ml-4 py-1 px-4 rounded">
                        <div class="flex" [tooltip]="literalService.get('trips.tooltips.totalDistance', true)" [position]="TooltipPosition.BELOW">
                            <img [src]="images.distanceBooking" class="h-6 w-6" />
                            <label class="ml-1 mr-4 font-semibold text-base">{{ (tripDetails.distance | number:'1.0-2') || 0 }} km</label>
                        </div>
                        <div class="flex" [tooltip]="literalService.get('trips.tooltips.meanVelocity', true)" [position]="TooltipPosition.BELOW">
                            <img [src]="images.speed" class="h-6 w-6" />    
                            <label class="ml-1 mr-4 font-semibold text-base">{{ tripDetails.velocity || 0 }} km/h</label>
                        </div>
                        <div class="flex" [tooltip]="literalService.get('trips.tooltips.variationTime', true)" [position]="TooltipPosition.BELOW">
                            <img [src]="images.clock" class="h-6 w-6"/>
                            <label class="ml-1 mr-4 font-semibold text-base"
                            [ngClass]="{
                                'ongoingOk': selectedTrip.status === 'Ongoing' && !isLate(selectedTrip.delay) && !isEarly(selectedTrip.delay),
                                'ongoingLate': selectedTrip.status === 'Ongoing' && isLate(selectedTrip.delay),
                                'ongoingEarly': selectedTrip.status === 'Ongoing' && isEarly(selectedTrip.delay)
                              }">{{ tripDetails.delay || 0 }} min</label>
                        </div>
                        <div class="flex items-center">
                            <div class="flex" [tooltip]="literalService.get('trips.tooltips.passengersOnBoard', true)" [position]="TooltipPosition.BELOW">
                                <img [src]="images.pax" class="h-6 w-6"/>
                                <label class="ml-1 mr-2 font-semibold text-base">{{ tripDetails.occupancy || 0 }}  /  {{ tripDetails.totalPax || 0 }} pax</label>
                            </div>
                            <!-- TODO: Uncomment this when we use me/permissions  -->
                            <!-- <img [src]="images.plus" class="h-5 w-5 cursor-pointer" (click)="showAddPaxEventEmitter.emit(selectedTrip.id)" data-modal-target="addPax" data-modal-toggle="addPax" [tooltip]="literalService.get('trips.actions.addPax.name', true)" [position]="TooltipPosition.ABOVE" [hidden]="!roleService.permissions['EXPEDITION']['UPDATE']"/> -->
                            <img [src]="images.plus" class="h-5 w-5 cursor-pointer" (click)="showAddPaxEventEmitter.emit(selectedTrip.id)" [tooltip]="literalService.get('trips.actions.addPax.name', true)" [position]="TooltipPosition.ABOVE" />
                        </div>
                    </div>
                </div>
            </article>
            <article class="pt-4 max-h-[calc(100vh-18rem)] overflow-auto">
                <div class="flex">
                    <div class="mr-4">
                        @for (stop of tripDetails.stops; track $index) {
                            @let arrival = getStopTime(stop, false);
                            @let departure = getStopTime(stop, true);
                            <article class="flex neutrals-grey-01-background w-27.5 rounded ps-2 pe-2 pt-2 pb-2 mb-10 justify-center">
                                <label class="text-base" [ngClass]="arrival.styleClass" [tooltip]="arrival.tooltip" [position]="TooltipPosition.BELOW">{{ arrival.value }}</label>
                                <article class="w-px neutrals-grey-03-background mr-2 ml-2"></article>
                                <label class="text-base" [ngClass]="departure.styleClass" [tooltip]="departure.tooltip" [position]="TooltipPosition.BELOW">{{ departure.value }}</label>
                            </article>
                        }
                    </div>
                    <div class="ml-4 mt-2 mr-4 w-1 justify-center">
                        @for (stop of tripDetails.stops; track $index) {
                            <article [class]="tripDetails.stops.length === $index + 1 ? '' : 'h-20'" [ngStyle]="getLineColor($index)">
                                <div [class]="'text-white h-6 w-6 rotate-180 rounded-[50%] ml-[-0.6rem]'" [ngStyle]="getStopColor($index)">
                                    <div class="h-3 w-3 rounded-[50%] bg-white ml-1.5 mt-1.5 absolute"></div>
                                </div>
                            </article>
                        }
                    </div>
                    <div class="ml-4 justify-center font-semibold text-base w-full pr-2">
                        @for (stop of tripDetails.stops; track $index) {
                            <article [id]="'stop' + stop.id" class="flex h-10 items-center mb-10">
                                <label class="mr-4 flex-auto">{{ stop.name }}</label>
                                <div class="flex-auto"></div>
                                @if (stop.passengersIn > 0 || stop.prmIn > 0) {
                                    <article class="secondary-green-light-background w-15 rounded ps-2 pe-2 mr-2 cursor-pointer" (click)="showViewPickUpsEventEmitter.emit(stop.id)">
                                    @if (stop.passengersIn > 0) {
                                        <div class="flex justify-center items-center">
                                            + {{ stop.passengersIn }}
                                            <img [src]="images.pax" alt="pax" class="h-4 w-4" />
                                        </div>
                                    }
                                    @if (stop.prmIn > 0) {
                                        <div class="flex justify-center items-center">
                                            + {{ stop.prmIn }}
                                            <img [src]="images.prm" alt="prm" class="h-4 w-4" />
                                        </div>
                                    }
                                    </article>
                                }
                                @if (stop.passengersOut > 0 || stop.prmOut > 0) {
                                    <article class="secondary-orange-light-background w-15 rounded ps-2 pe-2 mr-2 cursor-pointer" (click)="showViewDropOffsEventEmitter.emit(stop.id)">
                                    @if (stop.passengersOut > 0) {
                                        <div class="flex justify-center items-center">
                                            - {{ stop.passengersOut }}
                                            <img [src]="images.pax" alt="prm" class="h-4 w-4" />
                                        </div>
                                    }
                                    @if (stop.prmOut > 0) {
                                        <div class="flex justify-center items-center">
                                            - {{ stop.prmOut }}
                                            <img [src]="images.prm" alt="prm" class="h-4 w-4" />
                                        </div>
                                    }
                                    </article>
                                }
                                @if (stop.unexpectedPassengers !== 0) {
                                    <article class="primary-green-2-background w-12.5 rounded ps-2 pe-2 mr-2">
                                        <div class="flex justify-center items-center">
                                            + {{ stop.unexpectedPassengers }}
                                        </div>
                                    </article>
                                }
                                @if (stop.changeover) {
                                    <article class="primary-purple-light-2-background w-12.5 rounded ps-2 pe-2 pt-1 pb-1 mr-2  cursor-pointer" (click)="showViewChangeOversEventEmitter.emit(stop.id)">
                                        <div class="flex justify-center items-center">
                                            <img [src]="images.changeover" alt="changeover" class="h-4 w-4" />
                                        </div>
                                    </article>
                                }
                            </article>
                        }
                    </div>
                </div>
            </article>
            <article>
                <div class="h-px neutrals-grey-02-background ml-4 mr-4"></div>
            </article>
            <article>
                <div class="text-right pt-4 mr-4">
                    @if (tripDetails.creatorName || tripDetails.createdAt) {
                        <p class="changelog primary-purple-light-text font-light text-sm">{{ literalService.get('created', true) }}
                            @if (tripDetails.creatorName) {
                                <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ tripDetails.creatorName }}</span>
                            }
                                {{ literalService.get('at') }} {{ utilsService.convertDate(tripDetails.createdAt) | date: 'dd/MM/yyyy HH:mm' }}
                        </p>
                    }
                    @if (tripDetails.modifierName || tripDetails.lastModifiedAt) {
                        <p class="changelog primary-purple-light-text font-light text-sm">{{ literalService.get('lastModification', true) }}
                            @if (tripDetails.modifierName) {
                                <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ tripDetails.modifierName }}</span>
                            }
                                {{ literalService.get('at') }} {{ utilsService.convertDate(tripDetails.lastModifiedAt) | date: 'dd/MM/yyyy HH:mm' }}
                        </p>
                    }
                </div>
            </article>
            @if (selectedTrip.status === 'Ongoing' || selectedTrip.status === 'Closed') {
                <div class="drivenRouteInfoContainer absolute bottom-0 flex flex-row gap-2 bg-white rounded-lg p-2" [ngClass]="{'-right-18': !expandedDrivenRoute, '-right-59.75': expandedDrivenRoute}">
                    <div class="flex flex-col gap-2">
                        <div class="flex flex-row gap-2 items-center">
                            <div class="flex w-5 justify-center" [tooltip]="literalService.get('trips.showDrivenRoute', true)" [position]="TooltipPosition.ABOVE">
                                <img [src]="images.trips.drivenPosition" alt="drivenRoutePin" class="w-5 h-5" />
                            </div>
                            <div class="flex w-5 justify-center" [tooltip]="literalService.get('trips.showDrivenRoute', true)" [position]="TooltipPosition.ABOVE">
                                <app-checkbox
                                    class="[&_label]:ml-0 [&_label]:gap-0"
                                    [checked]="showDrivenRoute"
                                    (onChange)="onShowDrivenRouteChange($event)"
                                />
                            </div>
                        </div>
                        <div class="flex flex-row gap-2 cursor-pointer" (click)="expandedDrivenRoute = !expandedDrivenRoute">
                            <div class="flex w-5 justify-center">
                                <img [src]="images.info" alt="drivenRouteInfo" class="w-5 h-5" />
                            </div>
                            <div class="flex w-5 justify-center">
                                <img [src]="images.arrowRight" alt="drivenRouteExpand" class="w-5 h-5" [ngClass]="{'actionRotateArrowOpen': !expandedDrivenRoute, 'actionRotateArrowClose': expandedDrivenRoute}" />
                            </div>
                        </div>
                    </div>
                    @if (expandedDrivenRoute) {
                        <div class="flex flex-row gap-2">
                            <article class="flex flex-col px-2 max-w-20 leading-4 text-sm justify-center">
                                {{ literalService.get('trips.drivenDistance', true) }}
                                <span class="font-semibold">{{ tripDetails.drivenKms && tripDetails.drivenKms > 0 ? tripDetails.drivenKms : '-' }} km</span>
                            </article>
                            <article class="flex flex-col px-2 max-w-20 leading-4 text-sm justify-center">
                                {{ literalService.get('trips.similarity', true) }}
                                <span class="font-semibold">{{ tripDetails.similarity && tripDetails.similarity > 0 ? tripDetails.similarity : '-' }}%</span>
                            </article>
                        </div>
                    }
                </div>
            }
        </div>
    }
</section>
